import { Secret } from '../types/secret';

type GetSecretsProps = {
  baseUrl: string;
  token: string;
  teamName: string;
};

export async function getSecrets({
  baseUrl,
  token,
  teamName,
}: GetSecretsProps): Promise<Secret[]> {
  if (!baseUrl || !token || !teamName) {
    throw new Error('Aws-Service plugin base URL or team name not available');
  }
  const fetchUrl = new URL(`${baseUrl}/secrets`);
  fetchUrl.search = new URLSearchParams({
    teamName,
  }).toString();

  const response = await fetch(fetchUrl.toString(), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error ${response.status}`);
  }
  const secrets = (await response.json()) as Secret[];

  return secrets.map(secret => ({
    ...secret,
    ChangedSince: Math.floor(
      (new Date().getTime() - new Date(secret.LastChangedDate).getTime()) /
        (1000 * 60 * 60 * 24),
    ),
  }));
}
